import { ANNUALLY, BillingPeriodType, MONTHLY } from '@constants/billingPeriods'

const PERIOD_MONTHLY_ID = 408
const PERIOD_ANNUALLY_ID = 411

export const getBillingPeriodId = ({
  billingPeriod
}: {
  billingPeriod: BillingPeriodType
}) => {
  switch (billingPeriod) {
    case MONTHLY:
      return PERIOD_MONTHLY_ID
    case ANNUALLY:
      return PERIOD_ANNUALLY_ID
    default:
      throw new Error(`Unsupported billing period: ${billingPeriod}`)
  }
}
